/**
 * A6 · #138 (Tanda A, 2026-10-22) — los días del CICLO de pago para «Mi rango».
 *
 * El ciclo va del 20 al 19 (`pay_period_window`, migración 042) y lo manda el
 * server (`monthly.periodStart` / `monthly.periodEnd`, fin inclusivo). La
 * tarjeta contaba el mes CALENDARIO de la etiqueta del período: el 22-oct
 * (período «noviembre») decía «quedan 8 días» (30 − 22) cuando quedan 28, y
 * el promedio dividía por 22 días cuando iban 3.
 *
 * Todo en fechas YYYY-MM-DD de New York, contadas como días UTC enteros: así
 * no hay hora local ni horario de verano que corra un día.
 */
export interface DiasDelCiclo {
  /** Día del ciclo de hoy, desde 1 (el día de inicio es el día 1). */
  diaDelCiclo: number;
  /** Días que quedan DESPUÉS de hoy hasta el fin inclusivo. */
  diasQueQuedan: number;
}

const DIA_MS = 86_400_000;

function diaUTC(ymd: string): number | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd);
  if (!m) return null;
  return Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])) / DIA_MS;
}

export function diasDelCiclo(
  hoyNY: string,
  periodStart: string | null | undefined,
  periodEnd: string | null | undefined,
): DiasDelCiclo | null {
  const hoy = diaUTC(hoyNY);
  const ini = periodStart ? diaUTC(periodStart) : null;
  const fin = periodEnd ? diaUTC(periodEnd) : null;
  if (hoy == null || ini == null || fin == null || fin < ini) return null;
  return {
    diaDelCiclo: Math.max(1, hoy - ini + 1),
    diasQueQuedan: Math.max(0, fin - hoy),
  };
}
